import { Component, OnInit } from "@angular/core";
import { GenreService } from "src/app/services/genre.service";
import { catchError, map, throwError } from "rxjs";
import { SeoServiceService } from "src/app/services/seo-service.service";

@Component({
  selector: "app-genre",
  templateUrl: "./genre.component.html",
  styleUrls: ["./genre.component.scss"],
})
export class GenreComponent implements OnInit {
  genrelist: any;
  myMap = new Map<string, string>([
    ["Flute", "learn-flute-online"],
    ["Bharat Natyam", "bharatnatyam-online-classes"],
    ["Keyboard", "keyboard-online-classes"],
    ["Harmonium", "learn-harmonium-online"],
    ["Guitar", "online-guitar-classes"],
    ["Carnatic Vocal", "carnatic-vocal-classes"],
    ["Hindustani Classical Vocal", "hindustani-vocal-classes"],
    ["Sitar", "online-sitar-classes"],
    ["Kathak", "kathak-dance-online-classes"],
    ["Theatre", "online-theatre-courses"],
    ["Tabla", "tabla-classes-online"],
  ]);

  constructor(
    private genre: GenreService,
    private seoService: SeoServiceService
  ) {}

  ngOnInit(): void {
    this.seoService.createLinkForCanonicalURL();
    this.getGenres();
  }

  getGenres() {
    this.genre
      .getgenre()
      .pipe(
        map((res: any) => {
          this.genrelist = res.details;
        }),
        catchError((error) => {
          console.error("Genre fetch error:", error);
          return throwError(() => error.message || error);
        })
      )
      .subscribe();
  }

  getImage(genre: string): string {
    const imageURL = genre.replace(/ /g, "_").toLowerCase();
    return `https://d2abnqj5vuy2s4.cloudfront.net/assets/images/genre/${imageURL}.png`;
  }

  getLink(item: any): string {
    const mapped = this.myMap.get(item.genre);
    if (mapped) return mapped;
    return item.slug;
  }
}
